import { Col } from "react-bootstrap";
import PersonReviewedObjective from "./PersonReviewedObjective";
import "./PersonReviewedObjectivesList.css";

function PersonReviewedObjectivesList({ objectives }) {
  return (
    <Col>
      {objectives.map((element) => (
        <PersonReviewedObjective
          key={element._id}
          id={element._id}
          description={element.description}
          grade={element.grade}
          weight={element.weight}
          lastCheckInProgress={element.lastCheckInProgress}
        />
      ))}
    </Col>
  );
}

export default PersonReviewedObjectivesList;
